module.exports = __webpack_public_path__ + "static/media/ticket_empty.d58bab72.svg";